import PageWrapper from "../../components/common/layout/PageWrapper";
import { useTranslation } from "react-i18next";
import useAppSelector from "../../../hooks/redux/base/useAppSelector";
import SEOfficialNoteEdit from "../../components/services/secondaryEducation/SEOfficialNoteEdit";

const SEOfficialNoteEditPage = () => {
  const { t } = useTranslation();

  const selectedService = useAppSelector((state) => {
    return state.SelectedService;
  });

  return (
    <PageWrapper title={t(`${selectedService.titleCode}.edit`)}>
      <SEOfficialNoteEdit />
    </PageWrapper>
  );
};

export default SEOfficialNoteEditPage;
